// 导航守卫插件 - 处理页面加载期间的导航问题
export default defineNuxtPlugin(() => {
  if (process.client) {
    let isNavigating = false
    
    // 监听路由开始导航
    const router = useRouter()
    
    router.beforeEach((to, from, next) => {
      isNavigating = true
      next()
    })
    
    router.afterEach(() => {
      isNavigating = false
    })
    
    // 处理浏览器前进/后退事件
    window.addEventListener('popstate', (event) => {
      if (isNavigating) {
        console.warn('Navigation interrupted by browser action')
        // 防止在导航期间的浏览器操作
        event.preventDefault()
        return false
      }
    })
    
    // 处理页面可见性变化
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && isNavigating) {
        console.warn('Page hidden during navigation')
      }
    })
    
    // 覆盖控制台错误，隐藏 MIME 类型错误
    const originalConsoleError = console.error
    console.error = function(...args) {
      const message = args[0]
      if (typeof message === 'string' && 
          (message.includes('MIME type') || 
           message.includes('Failed to fetch dynamically imported module'))) {
        console.warn('Navigation error intercepted:', message)
        return
      }
      originalConsoleError.apply(console, args)
    }
  }
})
